import Player from "@/components/LottiePlayer";

export default function MoreFeatures() {
  
  const features = [
    {
      title: "DATA DISCOVERY WORKSHOPS",
      text: "Together, we'll explore your current data landscape through collaborative workshops, analyzing your processes and identifying areas for improvement. Our hands-on approach ensures a thorough understanding of your business, allowing us to develop a customized \
       data strategy that addresses your specific challenges and objectives.",
      icon: "/assets/icons/seeding.json"
    },
     {
      title: "HOLISTIC DATA STRATEGY",
       text: "We'll help you craft a complete data strategy, covering all aspects from DataOps to data privacy. Our focus is on understanding your unique requirements, including data handling, protection \
        policies, and storage needs, all while ensuring compliance with regulations such as GDPR and CCPA.",
      icon: "/assets/icons/flow-chart.json"
    },
    {
      title: "ROBUST  DATA INFRASTRUCTURE",
      text: "Our data engineering services go beyond merely collecting and storing data. We'll guide you in building a scalable and secure data infrastructure, ensuring seamless data ingestion, storage, and access for all users and applications. Our experts design scalable data storage solutions, data lakes, and backup systems to meet your needs and support your organization's growth.",
      icon: "/assets/icons/data-portal.json"
    },
    {
      title: "EFFICIENT DATA PIPELINES (ETL)",
      text: "We'll streamline your data pipelines, focusing on converting raw data into easily understandable and actionable formats. Our ETL process expertise guarantees a seamless data transformation, facilitating smooth cross-referencing. This crucial stage involves cleaning, enriching, and reorganizing data, ensuring efficient utilization by various applications and data analysts.",
      icon: "/assets/icons/robot.json"
    },
    {
      title: "INTUITIVE DATA FRONTEND",
      text: "Information must be displayed and searched through interfaces that allow for rapid iteration, reporting, and informing different end users. Make data exploration a breeze with our customized data cataloging, visualization, and exploratory data analysis solutions. We'll help you create dynamic dashboards and intuitive interfaces that enable rapid insights for various users across your organization.",
      icon: "/assets/icons/repair-tools.json"
    },
    {
      title: "DATA INTELLIGENCE: ML AND AI",
      text: "With a solid data foundation in place, we can utilize the previously built infrastructure to build advanced statistical and machine learning models to maximize the value derived from your data. Our process includes building predictive analytics, forecasting models, and navigating complex data, delivering data & insights for your business needs.",
      icon: "/assets/icons/connection.json"
    },
  ]

  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-8 ">
        <div className="text-center text-maingray" tabIndex={0}>
          <h3 className="mb-8 text-4xl md:text-5xl tracking-tight leading-tight font-bold md:leading-tight">
            How it works
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto  max-w-4xl">
            We work closely with your team to understand your unique business needs, delivering tailored solutions that enhance your data infrastructure, streamline data workflows, and improve data quality. 
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl grid grid-cols-1 lg:grid-cols-2 gap-14 px-4">
        {features.map((feature) => (
          <>
            <div tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
              <Player
                autoplay
                loop
                src={feature.icon}
                style={{ height: "80px", width: "80px" }}
              />
              <h3 className="font-['Inter'] text-xl font-bold text-orange-400  py-2"> {feature.title} </h3>
              <p className="body-text"> {feature.text} </p>
            </div>
            </>
        ))}
      </div>
    </section>
  );
}